import Component from "gia/Component";
import gsap from "gsap";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    //
    this.funcLaunch = this._reveal.bind(this);

    this._fx();
    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  _fx() {
    this.animate();
  }

  _reveal() {
    this.animation.play();
  }

  animate() {
    this.animation = gsap.timeline({ paused: true });

    this.animation.add([
      gsap.fromTo(
        this.ref.desc,
        {
          autoAlpha: 0,
        },
        {
          onStart: () => this.DOM.view.classList.add("is-inview"),
          autoAlpha: 1,
          ease: "cubic.out",
          duration: 1,
        }
      ),
    ]);
  }

  unmount() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    Channels.removeListener("transition::end", this.funcLaunch);
  }
}
